import React from "react";
import {Col, FormGroup, Input, Label, Row} from "reactstrap";

// component
import {LangController} from "../../../components/tabs/langController";

// labels
import {
    FL_INCLUDE,
    FL_LONG_DESCRIPTION,
    FL_NAME,
    FL_SHORT_DESCRIPTION
} from "../../../components/i18n/formLabels";

const AdmissionLangs = props => {
    const setDataDefault = (activeLangs, setLangChilds) => {
        const items = activeLangs.map( lang => ({
            id: '',
            lang: { id:lang?.id, name:lang?.name, showOrder:lang?.showOrder },
            name :  '' ,
            included: '',
            description :  '' ,
            slogan : '' ,
            longDescription :  '' ,
            descriptionActivity :  '' ,
            recomendations :  '' ,
            importantInfo : '' ,
            duration : '' ,
            days : '' ,
            logo : '' ,
        }) )

        setLangChilds(items);
    }

    const getFormulary = (child, index, disableInputs, onInputChange) => <>
        <Row>
            <Col md={"12"}>
                <FormGroup>
                    <Label >{FL_NAME}</Label>
                    <Input type="textarea"
                           name="name"
                           rows="1"
                           value= { child.name || '' }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md={"12"}>
                <FormGroup>
                    <Label >Slogan</Label>
                    <Input type="textarea"
                           name="slogan"
                           rows="1"
                           value= { child.slogan || '' }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md={"12"}>
                <FormGroup>
                    <Label >Duración</Label>
                    <Input type="textarea"
                           name="duration"
                           rows="1"
                           value= { child.duration || '' }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md={"12"}>
                <FormGroup>
                    <Label >Dias</Label>
                    <Input type="textarea"
                           name="days"
                           rows="1"
                           value= { child.days || '' }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md={"12"}>
                <FormGroup>
                    <Label >Logo</Label>
                    <Input type="textarea"
                           name="logo"
                           rows="1"
                           value= { child.logo || '' }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>

            <Col md={"12"}>
                <FormGroup>
                    <Label >{FL_SHORT_DESCRIPTION}</Label>
                    <Input type="textarea"
                           name="description"
                           rows="3"
                           value= { child.description || '' }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>

            <Col md={"6"}>
                <FormGroup>
                    <Label >{FL_INCLUDE}</Label>
                    <Input type="textarea"
                           name="included"
                           rows="8"
                           value= { child.included || '' }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md={"6"}>
                <FormGroup>
                    <Label >Recomendaciones</Label>
                    <Input type="textarea"
                           name="recomendations"
                           rows="8"
                           value= { child.recomendations || '' }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>

            <Col md={"6"}>
                <FormGroup>
                    <Label >Descripción de la actividad</Label>
                    <Input
                        type="textarea"
                        name="descriptionActivity"
                        rows="8"
                        value= { child.descriptionActivity || '' }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md={"6"}>
                <FormGroup>
                    <Label >Información importante</Label>
                    <Input type="textarea"
                           name="importantInfo"
                           rows="8"
                           value= { child.importantInfo || '' }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md={"12"}>
                <FormGroup>
                    <Label >{FL_LONG_DESCRIPTION}</Label>
                    <Input type="textarea"
                           name="longDescription"
                           rows="5"
                           value= { child.longDescription || '' }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
        </Row>
    </>

    return <LangController
        langs={props.langs}
        setLangs={props.setLangs}
        getFormulary={getFormulary}
        setDataDefault={setDataDefault}
        translatableLangs={props.translatableLangs}
    />
}

export default AdmissionLangs